import { gql } from '@apollo/client';
const UPDATE_PROJECTION_POINT = gql `
  mutation UpdateProjectionPoint(
    $projectionPointId: ID!
    $note: String
    $x: Float
    $y: Float
    $noteX: Float
    $noteY: Float
    $componentId: ID
  ) {
    updateProjectionPoint(
      projectionPointId: $projectionPointId
      note: $note
      x: $x
      y: $y
      noteX: $noteX
      noteY: $noteY
      componentId: $componentId
    ) {
      projectionPoint {
        id
        x
        y
        noteX
        noteY
        note
        component {
          id
          name
          productCategory {
            id
            type
            typeLabelPL
            typeLabelEN
            typeIcon
          }
        }
      }
    }
  }
`;
export default UPDATE_PROJECTION_POINT;
